(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.shopify-section-header');
        this.headerOverlay = document.querySelector('.header-overlay');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('always-fixed');
          if (!this.headerOverlay) {
            this.header.classList.add('shopify-section-header-sticky');
            this.headerOverlay.classList.add('color-background-1');
            this.headerOverlay.classList.remove('color-inverse');
          }
        }

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
          this.header.style.transform = 'translateY(-100%)';
        }

        if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
          this.header.classList.remove('color-background-2');
          this.header.style.transition = 'background var(--duration-short)';
          this.header.style.transform = 'translateY(0)';
        }

        if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
          this.header.style.transform = 'translateY(0)';
          this.header.style.transition = 'background var(--duration-short)';
          if (this.header.classList.contains('color-background-1')) {
            this.header.classList.add('color-background-2');
          }
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;

        if (document.querySelector('.search-modal.active')) return;
        if (document.querySelector('.burger-drawer.active')) {
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        }
        if (document.querySelector('.burger-drawer.active')) return;
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
        }
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
          this.headerOverlay.classList.remove('color-inverse');
        }
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        if (this.headerOverlay) {
          this.headerOverlay.classList.remove('color-background-1');
          if (!this.classList.contains('mega-menu-open')) {
            this.headerOverlay.classList.add('color-inverse');
          }
        }
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        if (this.disclosures) {
          this.disclosures.forEach((disclosure) => {
            disclosure.close();
          });
        }
        this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
        if (this.disclosureLists) {
          this.disclosureLists.forEach((disclosureList) => {
            disclosureList.setAttribute('hidden', true);
          });
        }
        this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
        if (this.disclosureButton) {
          this.disclosureButton.forEach((disclosureButton) => {
            disclosureButton.setAttribute('aria-expanded', false);
          });
        }
      }
    }

    customElements.define('sticky-header', StickyHeader);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        //this.showActiveMedia();
        this.constProductPageSwiperCall();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
      constProductPageSwiperCall(showActiveMedia) {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        let activeMediaIndex = 0;

        this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
          if (element == activeMedia) {
            activeMediaIndex = index;
          }
        });
        const prodPageSwiper = new Swiper('#product-page-swiper', {
          zoom: false,
          centeredSlides: false,
          slidesPerView: 1,
          autoheight: true,
          watchSlidesVisibility: false,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          init: false,
          navigation: {
            nextEl: '.swiper-button-next-prod-page',
            prevEl: '.swiper-button-prev-prod-page',
          },

          //on: {
          //	click: function (e) {
          //			if (this.zoom.scale === 1) {
          //			this.zoom.in();
          //			} else {
          //				this.zoom.out();
          //			}
          //	 },
          //},
        });

        prodPageSwiper.on('init', function () {
          prodPageSwiper.slideTo(activeMediaIndex, 0, false);
        });
        prodPageSwiper.init();

        document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
          if (prodPageSwiper && !prodPageSwiper.destroyed) {
            prodPageSwiper.destroy();
          }
          //prodPageSwiper.destroy()
        });
      }
    }

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations--single');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }

    customElements.define('product-modal', ProductModal);
    customElements.define('product-recommendations--single', ProductRecommendations);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["od-404"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('od-sequencer')) {
    class OdSequencer extends HTMLElement {
      connectedCallback() {
        this.machine = this.querySelector('[data-od404-machine]');
        if (!this.machine) return;
        this.machine.hidden = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rows = [...this.querySelectorAll('.od404__row')].map((row) => ({
          voice: row.dataset.voice,
          cells: [...row.querySelectorAll('.od404__cell')],
        }));
        this.digits = [...this.querySelectorAll('.od404__digit')];
        this.pattern = (this.dataset.pattern || '').split(',');
        this.bpm = parseInt(this.dataset.tempo, 10) || 112;
        this.step = 0;
        this.queue = [];
        this.playing = false;
        this.playBtn = this.querySelector('[data-od404-play]');
        this.playLabel = this.querySelector('[data-od404-play-label]');
        this.tempoInput = this.querySelector('[data-od404-tempo]');
        this.bpmOut = this.querySelector('[data-od404-bpm]');

        // Bass und Melodie: a-Moll, F, G (in Halbtönen über A)
        this.bassNotes = [0, 0, 0, 0, 0, 0, 0, 0, -4, -4, -4, -4, -2, -2, -2, -2];
        this.leadNotes = [12, 7, 3, 7, 12, 15, 12, 7, 8, 12, 15, 12, 10, 14, 17, 14];

        this.playBtn.addEventListener('click', () => this.toggle());
        this.tempoInput.addEventListener('input', () => {
          this.bpm = parseInt(this.tempoInput.value, 10);
          this.bpmOut.textContent = this.bpm + ' BPM';
        });
        this.querySelectorAll('[data-od404-action]').forEach((btn) =>
          btn.addEventListener('click', () => this.action(btn.dataset.od404Action))
        );

        // Malen: Maus gedrückt halten und über Kästchen ziehen
        this.paint = null;
        this.addEventListener('pointerdown', (e) => {
          const cell = e.target.closest('.od404__cell');
          if (!cell) return;
          e.preventDefault();
          this.classList.add('is-touched');
          this.paint = !cell.classList.contains('is-on');
          this.setCell(cell, this.paint, true);
          if (e.pointerType !== 'mouse' && cell.releasePointerCapture) cell.releasePointerCapture(e.pointerId);
        });
        this.addEventListener('pointerover', (e) => {
          if (this.paint === null) return;
          const cell = e.target.closest('.od404__cell');
          if (cell) this.setCell(cell, this.paint, false);
        });
        window.addEventListener('pointerup', () => (this.paint = null));
        window.addEventListener('pointercancel', () => (this.paint = null));
        // Tastatur (Enter/Leertaste auf einem Kästchen)
        this.addEventListener('click', (e) => {
          const cell = e.target.closest('.od404__cell');
          if (cell && e.detail === 0) {
            this.classList.add('is-touched');
            this.setCell(cell, !cell.classList.contains('is-on'), true);
          }
        });
        this.onKey = (e) => {
          if (e.code !== 'Space' || e.repeat) return;
          const t = e.target;
          if (t && (t.closest('button, input, textarea, select, a, [contenteditable]'))) return;
          e.preventDefault();
          this.toggle();
        };
        document.addEventListener('keydown', this.onKey);
        this.onHide = () => {
          if (document.hidden && this.playing) this.stop();
        };
        document.addEventListener('visibilitychange', this.onHide);
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('visibilitychange', this.onHide);
      }

      setCell(cell, on, preview) {
        if (cell.classList.contains('is-on') === on) return;
        cell.classList.toggle('is-on', on);
        cell.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && preview && !this.playing) {
          const row = this.rows.find((r) => r.cells.includes(cell));
          const ctx = this.audio();
          if (ctx && row) this.play(row.voice, parseInt(cell.dataset.step, 10), ctx.currentTime + 0.01);
        }
      }

      action(name) {
        this.classList.add('is-touched');
        this.rows.forEach((row, r) => {
          row.cells.forEach((cell, i) => {
            let on = false;
            if (name === 'reset') on = (this.pattern[r] || '').charAt(i) === '1';
            if (name === 'random') {
              const p = {
                kick: i % 4 === 0 ? 0.75 : 0.12,
                snare: i % 8 === 4 ? 0.85 : 0.07,
                hat: i % 2 === 0 ? 0.7 : 0.3,
                bass: i % 4 === 2 ? 0.6 : 0.18,
                lead: 0.28,
              }[row.voice];
              on = Math.random() < p;
            }
            cell.classList.toggle('is-on', on);
            cell.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      }

      audio() {
        if (this.ctx) {
          if (this.ctx.state === 'suspended') this.ctx.resume();
          return this.ctx;
        }
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        const ctx = new AC();
        this.ctx = ctx;
        const comp = ctx.createDynamicsCompressor();
        comp.threshold.value = -14;
        comp.ratio.value = 4;
        this.out = ctx.createGain();
        this.out.gain.value = 0.8;
        this.out.connect(comp);
        comp.connect(ctx.destination);
        const len = ctx.sampleRate;
        this.noise = ctx.createBuffer(1, len, ctx.sampleRate);
        const data = this.noise.getChannelData(0);
        for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
        return ctx;
      }

      env(t, peak, decay) {
        const g = this.ctx.createGain();
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(peak, t + 0.004);
        g.gain.exponentialRampToValueAtTime(0.0001, t + decay);
        g.connect(this.out);
        return g;
      }

      noiseSource(t, decay) {
        const src = this.ctx.createBufferSource();
        src.buffer = this.noise;
        src.start(t);
        src.stop(t + decay + 0.05);
        return src;
      }

      play(voice, step, t) {
        const ctx = this.ctx;
        if (voice === 'kick') {
          const o = ctx.createOscillator();
          o.type = 'sine';
          o.frequency.setValueAtTime(160, t);
          o.frequency.exponentialRampToValueAtTime(42, t + 0.14);
          o.connect(this.env(t, 0.95, 0.38));
          o.start(t);
          o.stop(t + 0.42);
        } else if (voice === 'snare') {
          const f = ctx.createBiquadFilter();
          f.type = 'highpass';
          f.frequency.value = 1300;
          this.noiseSource(t, 0.18).connect(f);
          f.connect(this.env(t, 0.45, 0.18));
          const o = ctx.createOscillator();
          o.type = 'triangle';
          o.frequency.setValueAtTime(200, t);
          o.frequency.exponentialRampToValueAtTime(120, t + 0.08);
          o.connect(this.env(t, 0.3, 0.1));
          o.start(t);
          o.stop(t + 0.12);
        } else if (voice === 'hat') {
          const f = ctx.createBiquadFilter();
          f.type = 'highpass';
          f.frequency.value = 7600;
          this.noiseSource(t, 0.05).connect(f);
          f.connect(this.env(t, 0.22, 0.05));
        } else if (voice === 'bass') {
          const freq = 110 * Math.pow(2, this.bassNotes[step] / 12);
          const o = ctx.createOscillator();
          o.type = 'sawtooth';
          o.frequency.value = freq;
          const f = ctx.createBiquadFilter();
          f.type = 'lowpass';
          f.Q.value = 7;
          f.frequency.setValueAtTime(900, t);
          f.frequency.exponentialRampToValueAtTime(180, t + 0.22);
          o.connect(f);
          f.connect(this.env(t, 0.32, 0.26));
          o.start(t);
          o.stop(t + 0.3);
        } else if (voice === 'lead') {
          const freq = 220 * Math.pow(2, this.leadNotes[step] / 12);
          const f = ctx.createBiquadFilter();
          f.type = 'lowpass';
          f.frequency.setValueAtTime(3200, t);
          f.frequency.exponentialRampToValueAtTime(700, t + 0.2);
          const g = this.env(t, 0.13, 0.22);
          f.connect(g);
          [-6, 6].forEach((detune) => {
            const o = ctx.createOscillator();
            o.type = 'square';
            o.frequency.value = freq;
            o.detune.value = detune;
            o.connect(f);
            o.start(t);
            o.stop(t + 0.25);
          });
        }
      }

      toggle() {
        this.playing ? this.stop() : this.start();
      }

      start() {
        const ctx = this.audio();
        if (!ctx) return;
        this.classList.add('is-touched');
        this.playing = true;
        this.step = 0;
        this.nextTime = ctx.currentTime + 0.06;
        this.queue = [];
        this.playBtn.setAttribute('aria-pressed', 'true');
        this.playLabel.textContent = 'Stopp';
        this.timer = setInterval(() => this.schedule(), 25);
        this.schedule();
        const draw = () => {
          if (!this.playing) return;
          this.draw();
          this.raf = requestAnimationFrame(draw);
        };
        this.raf = requestAnimationFrame(draw);
      }

      stop() {
        this.playing = false;
        clearInterval(this.timer);
        cancelAnimationFrame(this.raf);
        if (this.playBtn) {
          this.playBtn.setAttribute('aria-pressed', 'false');
          this.playLabel.textContent = 'Abspielen';
        }
        if (this.rows) this.rows.forEach((row) => row.cells.forEach((c) => c.classList.remove('is-head')));
        if (this.digits) this.digits.forEach((d) => d.classList.remove('is-hit'));
      }

      schedule() {
        const ctx = this.ctx;
        while (this.nextTime < ctx.currentTime + 0.12) {
          const step = this.step;
          let kick = false;
          this.rows.forEach((row) => {
            if (row.cells[step].classList.contains('is-on')) {
              this.play(row.voice, step, this.nextTime);
              if (row.voice === 'kick') kick = true;
            }
          });
          this.queue.push({ step, time: this.nextTime, kick });
          this.nextTime += 60 / this.bpm / 4;
          this.step = (step + 1) % 16;
        }
      }

      draw() {
        const now = this.ctx.currentTime;
        let cur = null;
        while (this.queue.length && this.queue[0].time <= now) cur = this.queue.shift();
        if (!cur) return;
        this.rows.forEach((row) =>
          row.cells.forEach((c, i) => c.classList.toggle('is-head', i === cur.step))
        );
        if (cur.kick) {
          const d = this.digits[(cur.step >> 2) % this.digits.length] || this.digits[0];
          this.digits.forEach((x) => x.classList.toggle('is-hit', x === d));
          if (!this.reduced && d && d.animate) {
            d.animate(
              [{ transform: 'translateY(-6%) scale(1.06)' }, { transform: 'none' }],
              { duration: 220, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
            );
          }
        }
      }
    }
    customElements.define('od-sequencer', OdSequencer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["od-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('od-timeline-init')) return;

    function init(root) {
      if (!root || root.dataset.odReady) return;
      root.dataset.odReady = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-od-item]'));
      var entries = Array.prototype.slice.call(root.querySelectorAll('[data-od-entry]'));
      var fill = root.querySelector('[data-od-fill]');
      var yearEl = root.querySelector('[data-od-year]');
      var list = root.querySelector('.od-timeline__list');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reduce && 'IntersectionObserver' in window) {
        root.classList.add('is-ready');
        var io = new IntersectionObserver(function (records) {
          records.forEach(function (r) {
            if (r.isIntersecting) {
              r.target.classList.add('is-visible');
              io.unobserve(r.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
        items.forEach(function (el) { io.observe(el); });
      }

      var currentYear = yearEl ? yearEl.textContent.trim() : '';
      function setYear(y) {
        if (!yearEl || !y || y === currentYear) return;
        currentYear = y;
        if (reduce) { yearEl.textContent = y; return; }
        yearEl.classList.add('is-changing');
        window.setTimeout(function () {
          yearEl.textContent = y;
          yearEl.classList.remove('is-changing');
        }, 200);
      }

      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        var mid = vh * 0.5;
        if (fill && list) {
          var rect = list.getBoundingClientRect();
          var p = (mid - rect.top) / Math.max(rect.height, 1);
          p = Math.min(1, Math.max(0, p));
          fill.style.setProperty('--od-progress', p.toFixed(4));
        }
        var active = null;
        for (var i = 0; i < entries.length; i++) {
          var r = entries[i].getBoundingClientRect();
          if (r.top <= mid) {
            active = entries[i];
            entries[i].classList.add('is-passed');
          } else {
            entries[i].classList.remove('is-passed');
          }
          entries[i].classList.remove('is-active');
        }
        if (active) {
          active.classList.add('is-active');
          setYear(active.getAttribute('data-year'));
        } else if (entries[0]) {
          setYear(entries[0].getAttribute('data-year'));
        }
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-od-timeline]').forEach(init);
    }

    customElements.define('od-timeline-init', class extends HTMLElement {});
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (typeof window.monochromeInitProductCardSwipers === 'function') {
              try {
                window.monochromeInitProductCardSwipers(this);
              } catch (sliderErr) {}
            }
            const initAnimated = () => {
              const blocks = document.querySelectorAll('.animated-block:not(.visible)');

              const observer = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      const block = entry.target;
                      block.classList.add('visible');
                      observer.unobserve(block);
                    }
                  });
                },
                { threshold: 0.1 }
              );

              blocks.forEach((block) => {
                observer.observe(block);
              });
            };
            initAnimated();
            const buttonHoverEffects = () => {
              if (window.innerWidth < 1200) return;
              function wrapLetters(element) {
                const text = element.textContent.trim();
                element.innerHTML = '';

                const wrapperSpan = document.createElement('span');
                wrapperSpan.className = 'wrapper';

                Array.from(text).forEach((char, charIndex) => {
                  const charSpan = document.createElement('span');
                  charSpan.className = 'char';
                  charSpan.textContent = char;
                  charSpan.style.setProperty('--char-index', charIndex + 1);
                  wrapperSpan.appendChild(charSpan);
                });

                element.appendChild(wrapperSpan);
              }

              document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
            };

            buttonHoverEffects();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
